import { useEffect, useState } from 'react';

/**
 * Custom hook that returns a boolean indicating if the component is currently mounted.
 *
 * @returns {boolean} - `true` if the component is mounted, `false` otherwise.
 *
 * @example
 * ```tsx
 * const MyComponent = () => {
 *   const isMounted = useIsMounted();
 *
 *   if (!isMounted) return null;
 *
 *   return <div>My Component</div>;
 * };
 * ```
 */
export const useIsMounted = () => {
  const [isMounted, setMounted] = useState(false);

  useEffect(() => setMounted(true), []);

  return isMounted;
};
